var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('info-chart', {
    attrs: {
      "chartSeries": _vm.overallSeries,
      "chartOptions": _vm.overallChartOptions,
      "title": "Overall Totals"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }